import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  FormControlLabel,
  Grid2,
  IconButton,
  Switch,
  Button,
  Typography,
} from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MaterialSelect";
import colors from "../../../../assest/theme/base/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import MessagePopup from "../../../Utils/MessagePopup";
import ConfirmDialog from "../../../Utils/ConfirmDialog";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "../../../../components/SnackbarProvider";
import { useLoading } from "../../../../context/loadingcontext";
import axiosInstance, { API_URL, FILE_URL } from "../../../Utils/url";

const Addcompany = ({ formClose, formType, setOpen, rowId }) => {
  //   const { isuser } = useContext(UserContext);

  const [insurerdata, setinsurerdata] = useState({
    insurer: "",
    companyname: "",
    uploadedFile: null,
    active: false,
    imageUrl: null,
    insurerStatus: "unchecked",
    companynameStatus: "unchecked",
  });

  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [dialogOpen, setDialogOpen] = useState(false);

  const [inputStatus, setinputStatus] = useState(false);
  const [insurenceNameOptions, setInsurenceNameOptions] = useState([]);
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();
  useEffect(() => {
    fetchInsurenceName();
  }, []);

  useEffect(() => {
    if (formType == "view") {
      setinputStatus(true);
    } else {
      setinputStatus(false);
    }
    fetchCompneyById();
  }, [formType]);
  const fetchCompneyById = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}v1/company-configuration/${rowId}/`
      );

      const success = response?.data?.success;
      const data = response?.data?.data;

      setinsurerdata({
        insurer: {
          value: data?.insurance_configuration,
          label: data?.insurance_name,
        },
        companyname: data?.company_name,
        uploadedFile: null,
        active: data?.is_active,
        insurerStatus: "success",
        companynameStatus: "success",
        imageUrl: `${FILE_URL}${data?.company_logo}`,
      });
    } catch (err) {
    } finally {
    }
  };

  const fetchInsurenceName = async () => {
    try {
      const response = await axiosInstance.get(`${API_URL}v1/insurance-name/`);

      setInsurenceNameOptions(response?.data?.data);
    } catch (error) {
      setInsurenceNameOptions([]);
    }
  };
  const handleAddCourseChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...insurerdata };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "insurer") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "companyname":
          {
            const alphaNLengthRegex = new RegExp("^.{1,30}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setinsurerdata(formState);
  };

  const hanldeConfirmDialogCancel = () => {
    setDialogOpen(false);
  };

  const handleSubmit = () => {
    setDialogOpen(true);
  };

  const reset = () => {
    setinsurerdata({
      ...insurerdata,
      insurer: "",
      companyname: "",
      uploadedFile: null,
      active: false,
      insurerStatus: "unchecked",
      companynameStatus: "unchecked",
    });
    formClose();
  };

  const isFormValid = () => {
    return insurerdata.insurerStatus == "success";
  };

  const hanldeConfirmDialogSubmit = async () => {
    setDialogOpen(false);
    setCirleLoading(true);
    try {
      const formData = new FormData();

      formData.append("insurance_configuration", insurerdata?.insurer?.value);
      formData.append("company_name", insurerdata?.companyname);
      formData.append("is_active", insurerdata?.active);
      if (insurerdata?.uploadedFile?.name) {
        formData.append("company_logo", insurerdata.uploadedFile);
      }

      const response =
        formType == "edit"
          ? await axiosInstance.put(
              `${API_URL}v1/company-configuration/${rowId}/`,
              formData
            )
          : await axiosInstance.post(
              `${API_URL}v1/company-configuration/`,
              formData
            );
      setOpen(false);
      showSnackbar(response?.data?.message, "success");
    } catch (err) {
      showSnackbar(err?.response?.data?.message, "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleToggleActive = () => {
    setinsurerdata((prev) => ({
      ...prev,
      active: !prev.active,
    }));
  };

  return (
    <>
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <ConfirmDialog
        open={dialogOpen}
        title="Confirm Popup"
        content="Are you sure you want to submit this record?"
        onClose={hanldeConfirmDialogCancel}
        onConfirm={hanldeConfirmDialogSubmit}
      />
      <Box sx={{ p: 3, mx: "auto", borderRadius: 2 }}>
        <MessagePopup
          message={popup.message}
          severity={popup.severity}
          open={popup.open}
          setPopup={setPopup}
        />
        <ConfirmDialog
          open={dialogOpen}
          title="Confirm Popup"
          content="Are you sure you want to submit this record?"
          onClose={hanldeConfirmDialogCancel}
          onConfirm={hanldeConfirmDialogSubmit}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", gap: 4 }}>
            <IconButton onClick={formClose}>
              <ArrowBackIcon sx={{ color: "#000" }} />
            </IconButton>{" "}
            <MaterialTypography
              sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
              mb={2}
            >
              New Company
            </MaterialTypography>
          </Box>
          <IconButton onClick={formClose}>
            <ClearIcon sx={{ color: "#000" }} />
          </IconButton>
        </Box>
        <Grid2 container spacing={1.5}>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Insurance name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialSelect
              name="insurer"
              placeholder={`Select Client`}
              value={insurerdata.insurer}
              options={insurenceNameOptions?.map((v) => ({
                value: v?.id,
                label: v?.insurance_name,
              }))}
              searchable={false}
              onChange={handleAddCourseChange}
              error={insurerdata.insurerStatus === "error" ? true : false}
              success={insurerdata.insurerStatus === "success" ? true : false}
              isDisabled={inputStatus}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6, md: 6 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Company Name
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <MaterialInput
              name="companyname"
              placeholder="Enter Company Name"
              value={insurerdata.companyname}
              onChange={handleAddCourseChange}
              error={insurerdata.companynameStatus === "error" ? true : false}
              success={
                insurerdata.companynameStatus === "success" ? true : false
              }
              disabled={inputStatus}
            />
            {insurerdata.companynameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Company Name must be 1 to 50 Alpha characters.
              </MaterialTypography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6, md: 6 }} sx={{ paddingLeft: "2%" }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel, Opacity: "0" }}
            >
              Active/Inactive
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <FormControlLabel
              control={
                <Switch
                  checked={insurerdata.active}
                  onChange={handleToggleActive}
                  color="primary"
                  disabled={inputStatus}
                />
              }
              disabled={inputStatus}
              label={insurerdata.active ? "Active" : "Inactive"}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              sx={{ color: colors.inputlabel }}
            >
              Upload Logo
              <span style={{ marginLeft: "2px", color: "red" }}>*</span>
            </MaterialTypography>
            <Box display="flex" alignItems="center">
              <Button
                variant="outlined"
                component="label"
                sx={{
                  flexGrow: 1,
                  height: 45,
                  textAlign: "left",
                  justifyContent: "flex-start",
                }}
              >
                {insurerdata.uploadedFile?.name || "Choose File"}
                <input
                  type="file"
                  hidden
                  accept=".png,.jpg,.jpeg,.pdf,.doc,.docx"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const allowedTypes = ["image/png", "image/jpeg"];
                      if (!allowedTypes.includes(file.type)) {
                        setPopup({
                          open: true,
                          message: "PNG, JPG,",
                          severity: "error",
                        });
                      } else {
                        setinsurerdata((prev) => ({
                          ...prev,
                          uploadedFile: file,
                          imageUrl: null,
                        }));
                      }
                    }
                  }}
                />
              </Button>

              {insurerdata.uploadedFile && (
                <IconButton
                  color="error"
                  onClick={() =>
                    setinsurerdata((prev) => ({ ...prev, uploadedFile: null }))
                  }
                  sx={{ ml: 1 }}
                  aria-label="delete file"
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
            {insurerdata.imageUrl && (
              <img
                src={insurerdata.imageUrl}
                width={50}
                height={50}
                style={{ objectFit: "contain" }}
              />
            )}

            {insurerdata.uploadedFile && (
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ mt: 1, display: "block" }}
              >
                {insurerdata.uploadedFile.name ||
                  insurerdata.uploadedFile.split("/").pop()}
              </Typography>
            )}
          </Grid2>

          <Grid2 size={{ xs: 12, md: 12, md: 12 }}>
            <Box display="flex" justifyContent="space-around" mt={3}>
              {inputStatus == false && (
                <MaterialButton
                  variant="contained"
                  sx={{
                    background: colors.buttonColor,
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                >
                  Submit
                </MaterialButton>
              )}
              <MaterialButton
                onClick={reset}
                variant="outlined"
                sx={{
                  color: colors.cancel,
                  borderColor: colors.cancel,
                  "&:hover": {
                    borderColor: colors.cancel,
                  },
                }}
              >
                Cancel
              </MaterialButton>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </>
  );
};

export default Addcompany;
